import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import ChangePass from '@/components/ChangePass'
import Publications from '@/components/Publications'
import Cart from '@/components/Cart'
import Manage from '@/components/Manage'
import Contact from '@/components/Contact'
import Checkout from '@/components/Checkout'
import Payment from '@/components/Payment'
import Partner from '@/components/Partner'
import PaymentReturn from '@/components/PaymentReturn'
import Orders from '@/components/Orders'
import AdminUsers from '@/components/admin/AdminUsers'
import AdminUsersView from '@/components/admin/AdminUsersView'
import AdminExpeditions from '@/components/admin/AdminExpeditions'
import AdminExpeditionsView from '@/components/admin/AdminExpeditionsView'
import AdminPublications from '@/components/admin/AdminPublications'
import AdminPublicationsView from '@/components/admin/AdminPublicationsView'
import AdminOrders from '@/components/admin/AdminOrders'
import AdminOrdersCreateView from '@/components/admin/AdminOrdersCreateView'
import AdminOrdersView from '@/components/admin/AdminOrdersView'
import AdminSignatures from '@/components/admin/AdminSignatures'
import AdminSignaturesView from '@/components/admin/AdminSignaturesView'
import ReportPublicationClients from '@/components/admin/ReportPublicationClients'
import ReportOrderPrefix from '@/components/reports/ReportOrderPrefix'
import PublicationPrice from '@/components/reports/PublicationPrice'
import PaidOrders from '@/components/reports/PaidOrders'
import ExpeditionList from '@/components/reports/ExpeditionList'
import ExpiredSignatures from '@/components/reports/ExpiredSignatures'
import SignaturesOrders from '../components/reports/SignaturesOrders.vue'
import Client from '../components/reports/Client.vue'
import Product from '../components/reports/Product.vue'

Vue.use(Router)

const router = new Router({
  base: '/',
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/login', name: 'login', component: Login },
    { path: '/change_pass/:hash', name: 'change_pass', component: ChangePass },
    { path: '/publications', name: 'publications', component: Publications },
    { path: '/manage', name: 'manage', component: Manage },
    { path: '/cart', name: 'cart', component: Cart },
    { path: '/contact', name: 'contact', component: Contact },
    { path: '/checkout', name: 'checkout', component: Checkout },
    { path: '/payment/:order', name: 'payment', component: Payment },
    { path: '/payment_return', name: 'payment_return', component: PaymentReturn },
    { path: '/orders', name: 'orders', component: Orders },
    { path: '/partner', name: 'partner', component: Partner },
    { path: '/admin/', name: 'admin', component: AdminSignatures },
    { path: '/admin/users', name: 'admin_users', component: AdminUsers },
    { path: '/admin/user/:id', name: 'admin_users_view', component: AdminUsersView },
    { path: '/admin/expeditions', name: 'admin_expeditions', component: AdminExpeditions },
    { path: '/admin/expedition/:id', name: 'admin_expeditions_view', component: AdminExpeditionsView },
    { path: '/admin/expedition/:id/:signature', name: 'admin_expeditions_view_signature', component: AdminExpeditionsView },    
    { path: '/admin/publications', name: 'admin_publications', component: AdminPublications },
    { path: '/admin/publication/:id', name: 'admin_publications_view', component: AdminPublicationsView },
    { path: '/admin/orders', name: 'admin_orders', component: AdminOrders },
    { path: '/admin/order/:id', name: 'admin_orders_view', component: AdminOrdersView },
    { path: '/admin/create_order', name: 'admin_create_order_view', component: AdminOrdersCreateView },
    { path: '/admin/signatures', name: 'admin_signatures', component: AdminSignatures },
    { path: '/admin/signature/:id', name: 'admin_signatures_view', component: AdminSignaturesView },
    { path: '/admin/report/publication_clients/:id', name: 'report_publication_clients', component: ReportPublicationClients },
    { path: '/admin/report/order_prefix/:prefix', name: 'order_prefix', component: ReportOrderPrefix },
    { path: '/admin/report/publication_price/', name: 'publication_price', component: PublicationPrice },
    { path: '/admin/report/paid_orders/', name: 'paid_orders', component: PaidOrders },
    { path: '/admin/report/expedition_list/', name: 'expedition_list', component: ExpeditionList },
    { path: '/admin/report/expired_signatures/', name: 'expired_signatures', component: ExpiredSignatures },
    { path: '/admin/report/signatures/', name: 'report_signatures', component: SignaturesOrders,  props: true, },
    { path: '/admin/report/renews/', name: 'report_renews', component: SignaturesOrders,  props: true, },
    { path: '/admin/report/orders/', name: 'report_orders', component: SignaturesOrders,  props: true, },
    { path: '/admin/report/product/', name: 'report_product', component: Product },
    { path: '/admin/report/client/', name: 'report_client', component: Client },

  ],
  mode: 'history'
})

export default router
